import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { EnvService } from './env.service';
import { CallBackTransformService } from './call-back-transform.service';
import { LocalStorageService } from './local-storage.service';
import { localStorageConstants } from '../localStorageConstants/localStorageConstants';

@Injectable({
  providedIn: 'root'
})
export class EmailAssessment {
  constructor(
    private envService: EnvService,
    private http: HttpClient,
    private callBackTransformService: CallBackTransformService,
    private localStorageService: LocalStorageService

  ) { }

  /**
   *  questionnaire by assessment ID
   * @param number assessmentId
   */
  questionnaireByAssessmentId(assessmentId): Observable<any> {
    const url = this.envService.apiUrl + 'questions-reviewer/' + assessmentId;
    return this.http.get<any>(url).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }

  /**
   * get Questions Anonymously
   * @param number questionnaireId
   */
  getQuestionsAnonymously(questionnaireId: any,agencyId:any): Observable<any> {
    const url =
      this.envService.apiUrl + 'questions-anonymous/' + questionnaireId  +'/'+ agencyId;
    return this.http.get<any>(url).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }

  getBrandingDetailsAnonymously(agencyId): Observable<any> {
    /**
     * Get branding details Anonymously
     * @date 6/30/2023 - 12:48:10 PM
     *
     * @type {string}
     */
    const url = this.envService.apiUrl + 'agency-branding-anonymous/' + agencyId;
    return this.http.get<any>(url).pipe(
      map(data => {
        data.result.branding = JSON.parse(data?.result?.branding);
        let formattedData = this.callBackTransformService.transformOutput(data);
       // this.localStorageService.saveInLocalStorage(localStorageConstants.brandingDetails, JSON.stringify(formattedData.Data));
        return formattedData;
      }),
      catchError(error => {
        return throwError(this.callBackTransformService.transformOutput(error));
      })
    );
  }

  /**
   * decrypt Assessment Email Link
   * @param number  decryptId
   */
  assessmentOtpVerification(assessmentData: any): Observable<any> {
    const url = this.envService.apiUrl + `assessmentemail-otp-verification`;
    return this.http.post<any>(url, JSON.stringify(assessmentData)).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }

  // getBrandingDetailsAnonymously(agencyId): Observable<any> {
  //   /**
  //    * Get branding details Anonymously
  //    * @date 6/30/2023 - 12:48:10 PM
  //    *
  //    * @type {string}
  //    */
  //   const url = this.envService.apiUrl + 'agency-branding-anonymous/' + agencyId;
  //   return this.http.get<any>(url).pipe(
  //     map(data => {
  //       data.result.branding = JSON.parse(data?.result?.branding);
  //       let formattedData = this.callBackTransformService.transformOutput(data);
  //      // this.localStorageService.saveInLocalStorage(localStorageConstants.brandingDetails, JSON.stringify(formattedData.Data));
  //       return formattedData;
  //     }),
  //     catchError(error => {
  //       return throwError(this.callBackTransformService.transformOutput(error));
  //     })
  //   );
  // }

  /**
   * otp  Link
   * @param number decryptId
   */
  assessmentOtp(decryptId: any): Observable<any> {
    const url = this.envService.apiUrl + `email-assessment-otp-onload`;
    return this.http
      .post<any>(url, JSON.stringify(decryptId))
      .pipe(
        map(output => {
          return this.callBackTransformService.transformOutput(output);
        }),
        catchError(err => {
          return throwError(this.callBackTransformService.transformOutput(err));
        })
      );
  }

  /**
   * resendAssessmentOtp
   * @param number decryptId
   */
  resendAssessmentOtp(decryptId: any): Observable<any> {
    const url = this.envService.apiUrl + `email-assessment-otp`;
    return this.http.post<any>(url, JSON.stringify(decryptId)).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }

  /**
   * save Assessment
   * @param number decryptId
   */
  saveAssessment(decryptId: any): Observable<any> {
    const url = this.envService.apiUrl + `assessment-anonymous`;
    return this.http.post<any>(url, JSON.stringify(decryptId)).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }

  resendLink(req:any): Observable<any> {
    const url = this.envService.apiUrl + `resend-Email-link`;
    return this.http.post<any>(url,req).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }
}
